import { FC, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import {
	changeAttachmentMode,
	changeSearchValue,
	clearAttachmentList,
	clearGlobalChecked,
	resetStep_7,
} from "toolkit/steps/stepSeven/stepSeven.slice";
import StepInfo from "../components";
import { Content } from "./Content/Content";
import Search from "components-new/Search";
import { ViewSwitch } from "./ViewSwitch/ViewSwitch";
import { Legend } from "./Legend/Legend";
import useDebounce from "hooks/useDebounce";
import { getSearchedData } from "toolkit/steps/stepSeven/stepSeven.thunks";
import { useParams } from "react-router-dom";
import styles from "./StepSeven.module.sass";
import cn from "classnames";
import { PAGINATION_COUNT_STEP_SEVEN } from "constant";

export const StepSeven: FC = () => {
	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);
	const { data, attachmentMode, searchValue } = useAppSelector((state) => state.stepSeven);
	const dispatch = useAppDispatch();
	const { organizationId } = useParams();

	const query = useDebounce(searchValue, 500);
	useEffect(() => {
		if (query as string) {
			dispatch(
				getSearchedData({
					organizationId: Number(organizationId),
					searchValue: String(query),
					attachmentMode,
					part: 1,
					count: PAGINATION_COUNT_STEP_SEVEN,
				}),
			);
		} else if (query === "") {
			console.log("");
		}
		//eslint-disable-next-line
	}, [query]);

	useEffect(() => {
		return () => {
			dispatch(resetStep_7());
		};
		//eslint-disable-next-line
	}, []);

	const attachmentModeToggler = (value: boolean) => {
		dispatch(changeAttachmentMode(value));
		// changeSearchValue тоже чистит пагинацию, поэтому resetPagination не нужен?
		// dispatch(resetPagination());
		dispatch(changeSearchValue(""));
		if (!value) {
			dispatch(clearAttachmentList());
			dispatch(clearGlobalChecked());
		}
	};

	return (
		<main className={styles.content}>
			<section className={styles.categorization}>
				<div className={styles.header}>
					<StepInfo
						stepTitle={"7. Присвоение ОКИИ реестровых номеров ФСТЭК и закрытие процесса"}
						info="Перечень объектов критической информационной инфраструктуры"
						companyName={selectedOrganization?.fullName}
					/>
					<div className={styles["header-item"]}>
						{attachmentMode ? (
							<button onClick={() => attachmentModeToggler(false)} className={styles["btn-choice"]}>
								Отмена
							</button>
						) : (
							<button
								onClick={() => attachmentModeToggler(true)}
								className={cn(
									styles["btn-choice"],
									!data.noLetter.length &&
										!data.repeatable.filter((object) => !object.fstekLetter).length &&
										styles["btn-choice-disabled-"],
								)}>
								Выбрать объекты для прикрепления письма
							</button>
						)}
						<Search
							className={styles.search}
							searchValue={searchValue}
							handleSearch={(e) => dispatch(changeSearchValue(e.target.value))}
						/>
						<ViewSwitch />
					</div>
				</div>
				{!attachmentMode && <Legend />}
				<Content />
			</section>
		</main>
	);
};
